import Data from 'data';
import { formatNumber } from 'utils/format';
import { processInfo } from 'logic/skills';

const spiritParams = [{min: 0, max: "maxspirit", name: "Spirit", buffs: false, show(rune, stats) {
  return !!stats.set_shenlong_2pc;
}}];

export const skills = {
  fistsofthunder: {
    params: spiritParams,
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "lit", coeff: 2}, "Third Hit Damage": {elem: "lit", coeff: 4}}; break;
      case "a": res = {"Damage": {elem: "lit", coeff: 2}, "Third Hit Damage": {elem: "lit", coeff: 4}, "Shockwave Damage": {elem: "lit", coeff: 1.2}}; break;
      case "e": res = {"Damage": {elem: "col", coeff: 2}, "Third Hit Damage": {elem: "col", coeff: 4}}; break;
      case "c": res = {"Damage": {elem: "lit", coeff: 2}, "Third Hit Damage": {elem: "lit", coeff: 4}, "Static Charge Damage": {elem: "lit", coeff: 0.3}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 2}, "Third Hit Damage": {elem: "phy", coeff: 4}}; break;
      case "b": res = {"Damage": {elem: "hol", coeff: 2}, "Third Hit Damage": {elem: "hol", coeff: 4}, "Arc Damage": {elem: "hol", coeff: 2.4}}; break;
      default: return;
      }
      if (stats.set_shenlong_2pc) {
        const percent = {[Data.itemSets.shenlong.name]: this.params[0].val * 2};
        for (const k in res) {
          res[k].percent = percent;
        }
      }
      const ias = (stats.passives.alacrity ? 1.15 : 1) * (stats.set_storms_2pc ? 1.25 : 1);
      res["DPS"] = {
        sum: "sequence",
        "First Hit": {src: "Damage", speed: 1.55 * ias, round: "up", fpa: 57},
        "Second Hit": {src: "Damage", speed: 1.55 * ias, round: "up", fpa: 57.391289},
        "Third Hit": {src: "Third Hit Damage", speed: ias, round: "up", fpa: 58.064510},
      };
      if (res["Shockwave Damage"]) res["DPS"]["Shockwave Damage"] = {count: 3};
      if (res["Arc Damage"]) res["DPS"]["Arc Damage"] = {};
      let spirit = (rune === "d" ? 20 : 14);
      if (stats.skills.breathofheaven === "d" && Data.skills.monk.breathofheaven.active) {
        spirit += 14;
      }
      spirit *= (1 + 0.01 * (stats.leg_bandofruechambers || 0)) * (1 + 0.01 * (stats.resourcegen || 0));
      res["Spirit/sec"] = {sum: true, "Spirit per Hit": {value: spirit, refspeed: "DPS", count: 3}};
      return res;
    },
  },
  deadlyreach: {
    params: spiritParams,
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 1.5}}; break;
      case "b": res = {"Damage": {elem: "phy", coeff: 1.5}}; break;
      case "e": res = {"Damage": {elem: "fir", coeff: 2.6}}; break;
      case "c": res = {"Damage": {elem: "lit", coeff: 1.5}, "Blast Damage": {elem: "lit", coeff: 2.15}}; break;
      case "d": res = {"Damage": {elem: "col", coeff: 1.5}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 1.5}}; break;
      default: return;
      }
      if (stats.set_shenlong_2pc) {
        const percent = {[Data.itemSets.shenlong.name]: this.params[0].val * 2};
        for (const k in res) {
          res[k].percent = percent;
        }
      }
      const ias = (stats.passives.alacrity ? 1.15 : 1) * (stats.set_storms_2pc ? 1.25 : 1);
      res["DPS"] = {
        sum: "sequence",
        "First Hit": {src: "Damage", speed: 1.5 * ias, round: "up", fpa: 55.384609},
        "Second Hit": {src: "Damage", speed: 1.5 * ias, round: "up", fpa: 57.391300},
        "Third Hit": {src: "Damage", speed: ias, round: "up", fpa: (rune === "c" ? 57.857132 : 58.064510)},
      };
      let spirit = 12;
      if (stats.skills.breathofheaven === "d" && Data.skills.monk.breathofheaven.active) {
        spirit += 14;
      }
      spirit *= (1 + 0.01 * (stats.leg_bandofruechambers || 0)) * (1 + 0.01 * (stats.resourcegen || 0));
      res["Spirit/sec"] = {sum: true, "Spirit per Hit": {value: spirit, refspeed: "DPS", count: 3}};
      return res;
    },
    active: false,
    buffs: {
      a: {damage: 15},
    },
  },
  cripplingwave: {
    params: [...spiritParams, {rune: "d", min: 0, max: 10, val: 1, name: "Enemies Hit", buffs: false}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 1.55}}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 2.55}}; break;
      case "c": res = {"Damage": {elem: "phy", coeff: 1.55}}; break;
      case "d": res = {"Damage": {elem: "hol", coeff: 1.55}}; break;
      case "b": res = {"Damage": {elem: "col", coeff: 1.55}}; break;
      case "e": res = {"Damage": {elem: "phy", coeff: 1.55}}; break;
      default: return;
      }
      if (stats.set_shenlong_2pc) {
        const percent = {[Data.itemSets.shenlong.name]: this.params[0].val * 2};
        for (const k in res) {
          res[k].percent = percent;
        }
      }
      const ias = (stats.passives.alacrity ? 1.15 : 1) * (stats.set_storms_2pc ? 1.25 : 1);
      res["DPS"] = {
        sum: "sequence",
        "First Hit": {src: "Damage", speed: 1.45 * ias, round: "up", fpa: 56.842102},
        "Second Hit": {src: "Damage", speed: 1.45 * ias, round: "up", fpa: 56.842102},
        "Third Hit": {src: "Damage", speed: ias, round: "up", fpa: 58},
      };
      let spirit = (rune === "d" ? 12 + this.params[1].val * 2.5 : 12);
      if (stats.skills.breathofheaven === "d" && Data.skills.monk.breathofheaven.active) {
        spirit += 14;
      }
      spirit *= (1 + 0.01 * (stats.leg_bandofruechambers || 0)) * (1 + 0.01 * (stats.resourcegen || 0));
      res["Spirit/sec"] = {sum: true, "Spirit per Hit": {value: spirit, refspeed: "DPS", count: 3}};
      return res;
    },
    active: true,
    buffs: {
      e: {dmgtaken: 10},
    },
  },
  wayofthehundredfists: {
    params: [...spiritParams,
             {rune: "c", min: 0, max: 3, val: 0, name: "Stacks"},
             {rune: "d", min: 0, max: 10, val: 0, name: "Stacks", inf: true}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 1.9}}; break;
      case "b": res = {"Damage": {elem: "lit", coeff: 1.9}, "Second Hit Damage": {elem: "lit", coeff: 4.23, total: true}}; break;
      case "c": res = {"Damage": {elem: "fir", coeff: 1.9}}; break;
      case "a": res = {"Damage": {elem: "hol", coeff: 1.9}, "Extra Damage": {elem: "hol", coeff: 0.6, total: true}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 1.9}}; break;
      case "e": res = {"Damage": {elem: "col", coeff: 1.9}, "Wave Damage": {elem: "col", coeff: 5}}; break;
      default: return;
      }
      if (stats.set_shenlong_2pc) {
        const percent = {[Data.itemSets.shenlong.name]: this.params[0].val * 2};
        for (const k in res) {
          res[k].percent = percent;
        }
      }
      const ias = (stats.passives.alacrity ? 1.15 : 1) * (stats.set_storms_2pc ? 1.25 : 1);
      res["DPS"] = {
        sum: "sequence",
        "First Hit": {src: "Damage", speed: 1.275 * ias, round: "up", fpa: 57},
        "Second Hit": {src: (rune === "b" ? "Second Hit Damage" : "Damage"), speed: 1.175 * ias, round: "up", fpa: 42},
        "Third Hit": {src: "Damage", speed: ias, round: "up", fpa: 57.599998},
      };
      if (stats.seasontheme_010) {
        if (rune === 'b') {
          res["Damage"] = res["Second Hit Damage"];
          delete res["Second Hit Damage"];
        }
        res["DPS"] = {sum: true, "Damage": {speed: 1.175 * ias, round: "up", fpa: 42}};
      }
      if (res["Dash Damage"]) res["DPS"]["Dash Damage"] = {};
      if (res["Wave Damage"]) res["DPS"]["Wave Damage"] = {};
      let spirit = 12;
      if (stats.skills.breathofheaven === "d" && Data.skills.monk.breathofheaven.active) {
        spirit += 14;
      }
      spirit *= (1 + 0.01 * (stats.leg_bandofruechambers || 0)) * (1 + 0.01 * (stats.resourcegen || 0));
      res["Spirit/sec"] = {sum: true, "Spirit per Hit": {value: spirit, refspeed: "DPS", count: 3}};
      return res;
    },
    active: true,
    buffs(rune, stats) {
      if (rune === "c") return {ias: this.params[1].val * 5, extrams: this.params[1].val * 5};
      if (rune === "d") return {damage: this.params[2].val * 5};
    },
  },
  lashingtailkick: {
    active: true,
    activetip: "First 5-7 enemies",
    activeshow(rune, stats) {
      return !!(stats.leg_scarbringer || stats.leg_scarbringer_p6);
    },
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 7.55}}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 7.55}, "Burn Damage": {elem: "fir", coeff: 2.3, total: true}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 8.25}}; break;
      case "b": res = {"Damage": {elem: "fir", coeff: 7.55}}; break;
      case "e": res = {"Damage": {elem: "lit", coeff: 7.55}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 7.55}}; break;
      default: return;
      }
      if (stats.leg_gyananakashu) {
        res["Fireball Damage"] = {elem: "fir", coeff: 0.01 * stats.leg_gyananakashu};
      }
      if (this.active && (stats.leg_scarbringer || stats.leg_scarbringer_p6)) {
        res["Damage"].percent = {[Data.itemById.P42_Unique_Fist_013_x1.name]: (stats.leg_scarbringer_p6 || 300)};
        if (res["Burn Damage"]) {
          res["Burn Damage"].percent = res["Damage"].percent;
        }
      }
      res = Object.assign({"Cost": {cost: 50}, "DPS": {
        sum: true,
        "Damage": {fpa: 57.3913, speed: (stats.leg_riveradancers ? 1.5 : 1)},
      }}, res);
      if (res["Fireball Damage"]) {
        res["DPS"]["Fireball Damage"] = {fpa: 57.3913, speed: (stats.leg_riveradancers ? 1.5 : 1), nobp: true};
      }
      if (res["Burn Damage"]) {
        res["DPS"]["Burn Damage"] = {fpa: 57.3913, speed: (stats.leg_riveradancers ? 1.5 : 1), nobp: true};
      }
      if ((stats.leg_rabidstrike || stats.leg_rabidstrike_p71) && Data.skills.monk.epiphany.active) {
        const ext = {pet: true, percent: {}};
        if (stats.leg_rabidstrike_p71) ext.percent[Data.itemById.P71_Unique_Fist_003.name] = stats.leg_rabidstrike_p71;
        if (stats.leg_bindingsofthelessergods) ext.percent[Data.itemById.P71_Unique_Bracer_108.name] = stats.leg_bindingsofthelessergods;
        if (stats.leg_bindingsofthelessergods_p71) ext.percent[Data.itemById.P71_Unique_Bracer_108.name] = stats.leg_bindingsofthelessergods_p71;
        if (stats.leg_thecrudestboots_p71) ext.percent[Data.itemById.P71_Unique_Boots_010.name] = stats.leg_thecrudestboots_p71;
        for (const name of ["Damage", "Fireball Damage", "Burn Damage"]) {
          if (res[name]) {
            res[`Rabid Strike ${name}`] = {...res[name], ...ext};
            res["DPS"][`Rabid Strike ${name}`] = {...res["DPS"]["Damage"], nobp: true};
          }
        }
      }
      return res;
    },
  },
  tempestrush: {
    active: true,
    activetip: "3 or fewer targets",
    activeshow(rune, stats) {
      return !!(stats.leg_balance || stats.leg_balance_p6);
    },
    params: [{rune: "e", min: 1, max: 100, name: "Flurry Stacks", buffs: false}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Tick Damage": {elem: "phy", aps: true, coeff: 3.9}}; break;
      case "d": res = {"Tick Damage": {elem: "hol", aps: true, coeff: 5}}; break;
      case "b": res = {"Tick Damage": {elem: "phy", aps: true, coeff: 3.9}}; break;
      case "e": res = {"Tick Damage": {elem: "col", aps: true, coeff: 3.9}, "Flurry Damage": {elem: "col", coeff: 0.9, aps: true, addcoeff: [[0.9, this.params[0].val]]}}; break;
      case "c": res = {"Tick Damage": {elem: "lit", aps: true, coeff: 3.9}, "Field DPS": {elem: "lit", coeff: 1.35, aps: true, total: true}}; break;
      case "a": res = {"Tick Damage": {elem: "fir", aps: true, coeff: 3.9}}; break;
      default: return;
      }
      res["Tick Damage"].divide = {"Speed Factor": 5};
      if ((stats.leg_balance || stats.leg_balance_p6) && this.active) {
        res["Tick Damage"].chc = 100;
        if (rune === "e") res["Flurry Damage"].chc = 100;
      }
      return Object.assign({"Cost": {cost: (rune === "d" ? 25 : 30), speed: 1}, "DPS": {sum: true, "Tick Damage": {aps: 5}}}, res);
    },
  },
  waveoflight: {
    active: true,
    activetip: "3 or fewer targets",
    activeshow(rune, stats) {
      return !!stats.leg_kyoshirosblade;
    },
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "hol", coeff: 8.35}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 8.35}}; break;
      case "b": res = {"Damage": {elem: "fir", coeff: 8.3}}; break;
      case "d": res = {"Damage": {elem: "hol", coeff: 10.45}}; break;
      case "e": res = {"Damage": {elem: "col", coeff: 8.35}, "Wave Damage": {elem: "col", coeff: 8.2}}; break;
      case "c": res = {"Damage": {elem: "lit", coeff: 6.35}, "Residual Damage": {elem: "lit", coeff: 7.85, total: true}}; break;
      default: return;
      }
      if (stats.leg_kyoshirosblade) {
        const pct = {[Data.itemById.P4_Unique_Fist_102.name]: (this.active ? stats.leg_kyoshirosblade : 150)};
        for (const id in res) res[id].percent = pct;
      }
      const dps = {sum: true, "Damage": {speed: 1, fpa: 58.823528, round: "up"}};
      if (res["Wave Damage"]) dps["Wave Damage"] = {...dps["Damage"], nobp: true};
      if (res["Residual Damage"]) dps["Residual Damage"] = {...dps["Damage"], nobp: true};
      const rcr = {};
      if (stats.leg_incensetorchofthegrandtemple_p6) rcr.leg_incensetorchofthegrandtemple_p6 = 50;
      else if (stats.leg_incensetorchofthegrandtemple) rcr.leg_incensetorchofthegrandtemple = stats.leg_incensetorchofthegrandtemple;
      if ((stats.leg_rabidstrike || stats.leg_rabidstrike_p71) && Data.skills.monk.epiphany.active) {
        const ext = {pet: true, percent: {...res["Damage"].percent}};
        if (stats.leg_rabidstrike_p71) ext.percent[Data.itemById.P71_Unique_Fist_003.name] = stats.leg_rabidstrike_p71;
        if (stats.leg_bindingsofthelessergods) ext.percent[Data.itemById.P71_Unique_Bracer_108.name] = stats.leg_bindingsofthelessergods;
        if (stats.leg_bindingsofthelessergods_p71) ext.percent[Data.itemById.P71_Unique_Bracer_108.name] = stats.leg_bindingsofthelessergods_p71;
        if (stats.leg_thecrudestboots_p71) ext.percent[Data.itemById.P71_Unique_Boots_010.name] = stats.leg_thecrudestboots_p71;
        for (const name of ["Damage", "Wave Damage", "Residual Damage"]) {
          if (res[name]) {
            res[`Rabid Strike ${name}`] = {...res[name], ...ext};
            dps[`Rabid Strike ${name}`] = {...dps["Damage"], nobp: true};
          }
        }
      }
      res["DPS"] = dps;
      return Object.assign({"Cost": {cost: 75, rcr}}, res);
    },
  },
  blindingflash: {
    info: {
      x: {"Uptime": {duration: 3, cooldown: 15}},
      d: {"Uptime": {duration: 6, cooldown: 15}},
      c: {"Uptime": {duration: 3, cooldown: 15}},
      b: {"Uptime": {duration: 3, cooldown: 15}},
      e: {"Uptime": {duration: 3, cooldown: 15}},
      a: {"Uptime": {duration: 3, cooldown: 15}},
    },
    active: false,
    buffs(rune, stats) {
      if (rune === "a") return {damage: 29};
    },
  },
  breathofheaven: {
    info: {
      x: {"Cooldown": {cooldown: 15, cdr: "leg_eyeofpeshkov"}},
      a: {"Cooldown": {cooldown: 15, cdr: "leg_eyeofpeshkov"}, "Damage": {elem: "hol", coeff: 5.05}},
      b: {"Cooldown": {cooldown: 15, cdr: "leg_eyeofpeshkov"}},
      c: {"Uptime": {duration: 9, cooldown: 15, cdr: "leg_eyeofpeshkov"}},
      d: {"Uptime": {duration: 5, cooldown: 15, cdr: "leg_eyeofpeshkov"}},
      e: {"Cooldown": {cooldown: 15, cdr: "leg_eyeofpeshkov"}},
    },
    active: true,
    buffs: {
      c: {damage: 10},
      d: {},
    },
  },
  serenity: {
    info: {
      x: {"Uptime": {duration: 3, cooldown: 16, after: true}},
      a: {"Uptime": {duration: 3, cooldown: 16, after: true}},
      e: {"DPS": {elem: "phy", coeff: 4.38, total: true}, "Uptime": {duration: 3, cooldown: 16, after: true}},
      d: {"Uptime": {duration: 3, cooldown: 16, after: true}},
      c: {"Uptime": {duration: 4, cooldown: 16, after: true}},
      b: {"Uptime": {duration: 3, cooldown: 16, after: true}},
    },
  },
  innersanctuary: {
    info: {
      x: {"Uptime": {duration: 6, cooldown: 20}},
      b: {"Uptime": {duration: 8, cooldown: 20}},
      d: {"Uptime": {duration: 6, cooldown: 20}},
      c: {"Uptime": {duration: 6, cooldown: 20}},
      a: {"Uptime": {duration: 6, cooldown: 20}},
      e: {"Uptime": {duration: 6, cooldown: 20}},
    },
    active: false,
    buffs(rune, stats) {
      const res = {dmgred: 55};
      if (rune === "d") res.regen = 35779 + (stats.regen || 0) * 0.07;
      return res;
    },
  },
  dashingstrike: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 3.7}}; break;
      case "b": res = {"Damage": {elem: "hol", coeff: 3.7}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 3.7}}; break;
      case "d": res = {"Damage": {elem: "lit", coeff: 3.7}}; break;
      case "e": res = {"Damage": {elem: "fir", coeff: 3.7}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 3.7}, "Barrage Damage": {elem: "phy", coeff: 9.75, total: true}}; break;
      default: return;
      }
      if (stats.set_storms_4pc) {
        res["Cost"] = {cost: 25};
      }
      if (stats.set_storms_6pc && Data.itemaffixes.set_storms_6pc.active) {
        res["Damage"].coeff = 600;
      }
      return Object.assign({"Cooldown": {cooldown: 8}}, res);
    },
    active: false,
    buffs: {
      b: {extrams: 20},
      c: {dodge: 40},
      e: {ias: 15},
    },
  },
  explodingpalm: {
    info(rune, stats) {
      const expl = {};
      if (stats.leg_thefistofazturrasq) {
        expl[Data.itemById.Unique_Fist_009_x1.name] = stats.leg_thefistofazturrasq;
      }
      if (stats.leg_thefistofazturrasq_p2) {
        expl[Data.itemById.P4_Unique_Fist_009_x1.name] = stats.leg_thefistofazturrasq_p2;
      }
      if (stats.leg_thefistofazturrasq_p6) {
        expl[Data.itemById.P61_Unique_Fist_009_x1.name] = stats.leg_thefistofazturrasq_p6;
      }
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 12, total: true}, "Explosion Damage": {elem: "phy", coeff: 27.7, percent: expl}}; break;
      case "c": res = {"Damage": {elem: "phy", coeff: 12, total: true}, "Explosion Damage": {elem: "phy", coeff: 27.7, percent: expl}}; break;
      case "d": res = {"Damage": {elem: "hol", coeff: 12, total: true}, "Explosion Damage": {elem: "hol", coeff: 27.7, percent: expl}}; break;
      case "b": res = {"Explosion Damage": {elem: "col", coeff: 63.05, percent: expl}}; break;
      case "a": res = {"Damage": {elem: "lit", coeff: 12, total: true}, "Explosion Damage": {elem: "lit", coeff: 27.7, percent: expl}}; break;
      case "e": res = {"Damage": {elem: "fir", coeff: 18.75, total: true}, "Explosion Damage": {elem: "fir", coeff: 32.6, percent: expl, total: true}}; break;
      default: return;
      }
      return Object.assign({"Cost": {cost: 40}}, res);
    },
    active: false,
    buffs: {
      c: {dmgtaken: 15},
    },
  },
  sweepingwind: {
    params: [{min: 0, max: "3+(leg_vengefulwind?3:0)+leg_vengefulwind_p2+(leg_vengefulwind_p67?10:0)", name: "Stacks", buffs: false}],
    info(rune, stats) {
      const res = {"Cost": {cost: 75}, "DPS": {elem: "phy", aps: true, coeff: 1.05, factors: {"Stacks": this.params[0].val}, total: true}};
      if (rune === "e") res["DPS"].elem = "col";
      if (rune === "a" || stats.set_justice_2pc) res["DPS"].coeff = 1.45;
      if (rune === "b") res["DPS"].elem = "fir";
      if (rune === "d") res["DPS"].elem = "hol";
      if (rune === "c") res["DPS"].elem = "lit";
      if (rune === "c" || stats.set_justice_2pc) res["Tornado Damage"] = {elem: "lit", coeff: 0.95};
      if (!this.params[0].val) delete res["DPS"];
      return res;
    },
    passive(rune, stats) {
      const buffs = {};
      if ((rune === "d" || stats.set_justice_2pc) && this.params[0].val >= 3) buffs.spiritregen = 8;
      if (stats.set_sunwuko_6pc && this.params[0].val) buffs.dmgmul = {skills: ["lashingtailkick", "tempestrush", "waveoflight"], percent: 1500 * this.params[0].val};
      if (stats.set_justice_2pc) buffs.extrams = 5 * this.params[0].val;
      return buffs;
    },
  },
  cyclonestrike: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "hol", coeff: 2.61}}; break;
      case "d": res = {"Damage": {elem: "lit", coeff: 2.61}}; break;
      case "b": res = {"Damage": {elem: "hol", coeff: 2.61}}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 4.54}}; break;
      case "e": res = {"Damage": {elem: "col", coeff: 2.61}}; break;
      case "c": res = {"Damage": {elem: "hol", coeff: 2.61}, "Healing": formatNumber(31036 + (stats.healbonus || 0) * 0.17, 0, 10000)}; break;
      default: return;
      }
      return Object.assign({"Cost": {cost: (rune === "d" ? 26 : 50)}}, res);
    },
  },
  sevensidedstrike: {
    info(rune, stats) {
      let res;
      const hits = 7 + (stats.leg_lionsclaw ? 7 : 0);
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 56.77, divide: {"Base Hits": 7}}, "Total Damage": {sum: true, "Damage": {count: hits}}}; break;
      case "a": res = {"Damage": {elem: "lit", coeff: 82.85, divide: {"Base Hits": 7}}, "Total Damage": {sum: true, "Damage": {count: hits}}}; break;
      case "b": res = {"Damage": {elem: "fir", coeff: 56.77, divide: {"Base Hits": 7}}, "Burn Damage": {elem: "fir", coeff: 6.3, total: true}, "Total Damage": {sum: true, "Damage": {count: 7}, "Burn Damage": {count: hits}}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 56.77, divide: {"Base Hits": 7}}, "Total Damage": {sum: true, "Damage": {count: hits}}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 56.77, divide: {"Base Hits": 7}}, "Total Damage": {sum: true, "Damage": {count: hits}}}; break;
      case "e": res = {"Damage": {elem: "hol", coeff: 8.77}, "Total Damage": {sum: true, "Damage": {count: hits}}}; break;
      default: break;
      }
      if (stats.set_uliana_4pc) {
        res["Damage"].factors = {[Data.itemSets.uliana.name]: 7.77 * hits};
      }
      if ((stats.leg_gungdogear || stats.leg_gungdogear_p610) && stats.set_uliana_6pc) {
        const ep_rune = (stats.skills.explodingpalm || "x");
        let ep_info = Data.skills.monk.explodingpalm.info(ep_rune, stats);
        ep_info = processInfo(ep_info, {skill: ["explodingpalm", ep_rune], stats, notext: true});
        res["Exploding Palm Damage"] = {sum: true};
        res["Exploding Palm Damage"][Data.skills.monk.explodingpalm.name] = {
          value: ep_info["Explosion Damage"].value, count: (stats.leg_lionsclaw ? 14 : 7),
        };
      }
      const base = {"Cooldown": {cooldown: (rune === "d" ? 14 : 30), cdr: "leg_theflowofeternity+leg_theflowofeternity_p2"}};
      if (rune !== "c") base["Cost"] = {cost: 50};
      return Object.assign(base, res);
    },
    active: true,
    buffs(rune, stats) {
      if (stats.leg_bindingofthelost || stats.leg_bindingofthelost_p6) {
        return {dmgred: (stats.leg_bindingofthelost || stats.leg_bindingofthelost_p6) * (7 + (stats.leg_lionsclaw ? 7 : 0))};
      }
    },
  },
  mystically: {
    params: [
      {
        min: stats => stats.leg_thecrudestboots || stats.leg_thecrudestboots_p71 ? 2 : 1,
        max: 10,
        name: "Count",
        buffs: false,
        show: (rune, stats) => !!stats.set_inna_6pc,
      }
    ],
    info(rune, stats) {
      const res = {"Cooldown": {cooldown: 30}};
      const pct = {};
      if (stats.set_inna_2pc) pct[Data.itemSets.inna.name] = 100;
      const count = stats.set_inna_6pc ? this.params[0].val : (stats.leg_thecrudestboots || stats.leg_thecrudestboots_p71 ? 2 : 1);
      let bonus = null;
      if (stats.leg_bindingsofthelessergods_p71 && Data.itemaffixes.leg_bindingsofthelessergods_p71.active) {
        bonus = {[Data.itemById.P71_Unique_Bracer_108.name]: stats.leg_bindingsofthelessergods_p71};
      }

      res["Damage"] = {
        elem: Data.skilltips.monk.mystically.elements[rune],
        pet: true,
        aps: true,
        percent: bonus,
        coeff: 1.3,
      };

      res["DPS"] = {sum: true, "Damage": {pet: 40, speed: 1, count}};
      /*if ("x" in runes) {
        res["Activated Damage"] = {elem: "phy", pet: true, aps: true, coeff: 1.3,
          percent: Object.assign({"Activation": 50}, pct)};
      }*/ // NOT WORKING
      if (rune === "b") {
        res["Wave Damage"] = {elem: "col", pet: true, aps: true, coeff: 6.25, factors: {"Count": 7 * count}, percent: bonus};
      }
      if (rune === "a") {
        const exp = res["Explosion Damage"] = {elem: "fir", pet: true, aps: true, coeff: 19.2, factors: {"Count": 2 * count}, percent: bonus};
        if (exp.percent) {
          exp.percent = {[Data.itemById.P71_Unique_Bracer_108.name]: 3 * exp.percent[Data.itemById.P71_Unique_Bracer_108.name]};
        }
      }
      if (rune === "c") {
        res["Boulder DPS"] = {elem: "phy", pet: true, aps: true, coeff: 45, total: true, factors: {"Count": count}, percent: bonus};
      }
      return res;
    },
    passive(rune, stats) {
      const count = (stats.leg_thecrudestboots || stats.leg_thecrudestboots_p71 ? 2 : 1) * (stats.set_inna_2pc ? 2 : 1);
      const res = {};
      if (rune === "a" || stats.set_inna_6pc) res.damage = 10 * count;
      if (rune === "d" || stats.set_inna_6pc) res.spiritregen = 4 * count;
      if (rune === "e" || stats.set_inna_6pc) res.regen = (10728.42 + stats.regen * 0.07) * count;
      if (rune === "c" || stats.set_inna_6pc) res.life = 20 * count;
      return res;
    },
  },
  epiphany: {
    info: {
      "*": {"Uptime": {duration: 15, cooldown: 60}},
      b: {"Healing": "@16093+0.04*healbonus"},
      d: {"Extra Damage": {elem: "fir", coeff: 3.53}},
    },
    active: false,
    buffs: {
      x: {ccr: 100, spiritregen: 20},
      a: {ccr: 100, spiritregen: 20, dmgred: 50},
      e: {ccr: 100, spiritregen: 20},
      b: {ccr: 100, spiritregen: 20},
      c: {ccr: 100, spiritregen: 45},
      d: {ccr: 100, spiritregen: 20},
    },
  },
  mantraofsalvation: {
    info: {
      "*": {"Cost": {cost: 50, rcr: {chantofresonance: "passives.chantofresonance?50:0"}}},
    },
    active: false,
    buffs: {
      x: {resist_percent: 20},
      c: {resist_percent: 20},
      e: {resist_percent: 20},
      d: {resist_percent: 20},
      b: {resist_percent: 20},
      a: {resist_percent: 20},
    },
    passive(rune, stats) {
      const base = 20 * (stats.set_inna_2pc ? 2 : 1);
      switch (rune) {
      case "x": return {resist_percent: base};
      case "c": return {resist_percent: base, armor_percent: 20};
      case "e": return {resist_percent: base};
      case "d": return {resist_percent: base, extrams: 10};
      case "b": return {resist_percent: base + 20};
      case "a": return {resist_percent: base, dodge: 35};
      // no default
      }
    },
    follower(rune, stats) {
      const result = this.passive(rune, stats);
      if (this.active) {
        result.resist_percent += 20;
      }
      return result;
    },
  },
  mantraofretribution: {
    info: {
      "*": {"Cost": {cost: 50, rcr: {chantofresonance: "passives.chantofresonance?50:0"}}},
      x: {"Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)"}, "Activated Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)*2"}},
      a: {"Damage": {elem: "fir", coeff: "1.01*(set_inna_2pc?2:1)+1.01"}, "Activated Damage": {elem: "fir", coeff: "1.01*(set_inna_2pc?2:1)*2+2.02"}},
      b: {"Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)"}, "Activated Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)*2"}},
      c: {"Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)"}, "Activated Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)*2"}},
      d: {"Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)"}, "Activated Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)*2"}},
      e: {"Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)"}, "Activated Damage": {elem: "hol", coeff: "1.01*(set_inna_2pc?2:1)*2"}},
    },
    passive(rune, stats) {
      if (rune === "b") return {ias: 10};
    },
    follower(rune, stats) {
      return this.passive(rune, stats);
    },
  },
  mantraofhealing: {
    info: {
      "*": {"Cost": {cost: 50, rcr: {chantofresonance: "passives.chantofresonance?50:0"}}, "Shield": "@62064+healbonus*0.15"},
    },
    passive(rune, stats) {
      let regen = 10728.42;
      regen += (stats.regen || 0) * 0.07;
      regen *= (stats.set_inna_2pc ? 2 : 1);
      switch (rune) {
      case "x": return {regen: regen};
      case "a": return {regen: regen * 2};
      case "d": return {regen: regen, spiritregen: 3};
      case "b": return {regen: regen, lph: 3576 + (stats.lph || 0) * 0.2};
      case "c": return {regen: regen, life: 20};
      case "e": return {regen: regen};
      // no default
      }
    },
    follower(rune, stats) {
      switch (rune) {
      case "b": return {lph: 3576 + (stats.lph || 0) * 0.2};
      case "c": return {life: 20};
      // no default
      }
    },
  },
  mantraofconviction: {
    info: {
      "*": {"Cost": {cost: 50, rcr: {chantofresonance: "passives.chantofresonance?50:0"}}},
      b: {"DPS": {elem: "hol", weapon: "mainhand", coeff: 0.38, total: true}},
    },
    active: false,
    buffs: {
      x: {dmgtaken: 8},
      a: {dmgtaken: 8},
      e: {dmgtaken: 8},
      c: {dmgtaken: 8},
      d: {dmgtaken: 8},
      b: {dmgtaken: 8},
    },
    passive(rune, stats) {
      const base = 8 * (stats.set_inna_2pc ? 2 : 1);
      switch (rune) {
      case "x": return {dmgtaken: base};
      case "a": return {dmgtaken: base + 4};
      case "e": return {dmgtaken: base};
      case "c": return {dmgtaken: base};
      case "d": return {dmgtaken: base};
      case "b": return {dmgtaken: base};
      // no default
      }
    },
  },
};

export const passives = {
  resolve: {
  },
  fleetfooted: {
    buffs: {extrams: 10},
  },
  exaltedsoul: {
    buffs: {maxspirit: 50, spiritregen: 4},
  },
  transcendence: {
    buffs(stats) {
      return {lifespirit: 429 + 0.004 * stats.healbonus};
    },
  },
  chantofresonance: {
    buffs(stats) {
      if (stats.skills.mantraofsalvation || stats.skills.mantraofretribution ||
          stats.skills.mantraofhealing || stats.skills.mantraofconviction) {
        return {spiritregen: 4};
      }
    },
  },
  seizetheinitiative: {
    active: false,
    buffs: {ias: 30},
  },
  theguardianspath: {
    buffs(stats) {
      if (stats.info.mainhand.slot === "onehand" && stats.info.offhand && stats.info.offhand.slot === "onehand") {
        return {dodge: 35};
      } else if (stats.info.mainhand.slot === "twohand") {
        return {resourcegen: 15};
      }
    },
  },
  sixthsense: {
    buffs: {nonphys: 25},
  },
  determination: {
    params: [{min: 0, max: 5, name: "Nearby Enemies"}],
    buffs(stats) {
      return {damage: 4 * this.params[0].val};
    },
  },
  relentlessassault: {
    active: true,
    buffs: {dmgmul: 20},
  },
  beaconofytar: {
    buffs: {cdr: 20},
  },
  alacrity: {
  },
  harmony: {
    buffs(stats) {
      let single = (stats.resphy || 0) + (stats.resfir || 0) + (stats.rescol || 0) +
                   (stats.respsn || 0) + (stats.resarc || 0) + (stats.reslit || 0);
      single *= 0.4;
      return {
        resphy: single - (stats.resphy || 0) * 0.4,
        resfir: single - (stats.resfir || 0) * 0.4,
        rescol: single - (stats.rescol || 0) * 0.4,
        respsn: single - (stats.respsn || 0) * 0.4,
        resarc: single - (stats.resarc || 0) * 0.4,
        reslit: single - (stats.reslit || 0) * 0.4,
      };
    },
  },
  combinationstrike: {
    boxnames: [
      () => Data.skills.monk.fistsofthunder.name,
      () => Data.skills.monk.deadlyreach.name,
      () => Data.skills.monk.cripplingwave.name,
      () => Data.skills.monk.wayofthehundredfists.name,
    ],
    buffs(stats) {
      const skills = ['fistsofthunder', 'deadlyreach', 'cripplingwave', 'wayofthehundredfists'];
      const boxes = (this.boxvals[0] ? 1 : 0) + (this.boxvals[1] ? 1 : 0) + (this.boxvals[2] ? 1 : 0) + (this.boxvals[3] ? 1 : 0);
      return {
        dmgmul: {list: skills.map((sk, i) => ({skills: [sk], percent: 100 * (boxes - (this.boxvals[i] ? 1 : 0))}))},
      };
    },
  },
  neardeathexperience: {
  },
  unity: {
    params: [{min: 0, max: 4, val: 1, name: "Stacks"}],
    buffs(stats) {
      return {damage: 5 * this.params[0].val};
    },
  },
  momentum: {
    active: true,
    buffs: {damage: 20},
  },
  mythicrhythm: {
    active: false,
    buffs: {dmgmul: {skills: ["lashingtailkick", "tempestrush", "waveoflight",
      "dashingstrike", "explodingpalm", "sweepingwind", "cyclonestrike", "sevensidedstrike"], percent: 40}},
  },
};

export const partybuffs = {
  cripplingwave: {
    runelist: "e",
  },
  innersanctuary: {
    runelist: "*",
  },
  explodingpalm: {
    runelist: "c",
  },

  mantraofsalvation: {
    runelist: "*",
    boxnames: ["Activated", "Inna's Mantra"],
    buffs(rune, stats) {
      const base = 20 * (this.boxvals[1] ? 2 : 1);
      const res = {resist_percent: base + (this.boxvals[0] ? 20 : 0)};
      if (rune === "c") res.armor_percent = 20;
      if (rune === "d") res.extrams = 10;
      if (rune === "b") res.resist_percent += 20;
      if (rune === "a") res.dodge = 35;
      return res;
    },
  },
  mantraofretribution: {
    runelist: "b",
    boxnames: ["Inna's Mantra"],
    buffs(rune, stats) {
      if (rune === "b") return {ias: 10 * (this.boxvals[0] ? 2 : 1)};
    },
  },
  mantraofhealing: {
    runelist: "*",
    boxnames: ["Inna's Mantra"],
    buffs(rune, stats) {
      const base = 10728.42 * (this.boxvals[0] ? 2 : 1);
      switch (rune) {
      case "x": return {regen: base};
      case "a": return {regen: base + 10728.42};
      case "d": return {regen: base, spiritregen: 3};
      case "b": return {regen: base};
      case "c": return {regen: base, life: 20};
      case "e": return {regen: base};
      // no default
      }
    },
  },
  mantraofconviction: {
    runelist: "*",
    boxnames: ["Activated", "Inna's Mantra"],
    buffs(rune, stats) {
      const base = 8 * (this.boxvals[1] ? 2 : 1);
      const res = {dmgtaken: base};
      if (rune === "a") res.dmgtaken += 4;
      if (this.boxvals[0]) res.dmgtaken += 8;
      return res;
    },
  },

  unity: {
    buffs: {damage: 5},
  },
};
